const TEXT_ABOUT_ORGANIZATION =
  'Lokalna alternativa je grupa gradjana okupljena oko ideje kritike vlasti i razoblicavanja' +
  ' njenog stetnog delovanja i odluka...';

export { TEXT_ABOUT_ORGANIZATION };
